import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, IBetSettlementApiListResponse } from '@/types';

export const betSettlementList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IBetSettlementApiListResponse>> => {
    return axios.get('/api/bet/settlement', { ...config, params });
};
